module.exports = __webpack_public_path__ + "assets/media/evening.041785bb.mp3";